export default function debounce(func, wait) {
  let timer;
  let diff;
  let nextCallback;
  let previousPromiseReject;

  return function (...arg) {
    if (timer === undefined) {
      timer = Date.now();
      return Promise.resolve(func(...arg));
    } else {
      diff = Date.now() - timer;
      if (diff > wait) {
        timer = Date.now();
        return Promise.resolve(func(...arg));
      } else {
        if (typeof previousPromiseReject === 'function') {
          previousPromiseReject(new Error('Canceled'));
        }
        clearTimeout(nextCallback);
        const promise = new Promise((resolve, reject) => {
          previousPromiseReject = reject;
          nextCallback = setTimeout(async () => {
            await func(...arg);
            resolve();
          }, wait);
        });
        return promise;
      }
    }
  };
}

export { debounce };
